import {MessageActions, MessageActionType} from "./MessageActions";
import {UserMessage, UserMessageMinimalProjection} from "../http/protocol";
import {UserAction, UserActionTypes} from "../user/UserActions";


export enum MessageStatus {
    INITIAL, LOADING, DONE, ERROR
}
export interface MessageState {
    messages? : UserMessageMinimalProjection[]
    unread?:number;
    toasts? : UserMessage[];
    status? : MessageStatus;
    hasMore?: boolean;
    currentOffset?: number;
}

const initialState = {  
    status : MessageStatus.INITIAL, 
    messages : [], 
    toasts : [],
    hasMore: true,
    currentOffset: 0,
    unread: 0
}

export function messageReducer (state = initialState, action: MessageActions|UserAction) : MessageState {
    switch (action.type) {
        case UserActionTypes.BALANCE_RESPONSE:
            let messages : UserMessage[] = state.messages.concat();
            if(action.response.messages && action.response.messages.length > 0) {
                messages = action.response.messages.concat(messages);
            }
            //remove duplicate messages:
            let ids = messages.map(o => o.id)
            let filtered = messages.filter(({id}, index) => !ids.includes(id, index + 1))
            return {...state, messages : filtered, status : MessageStatus.DONE, toasts : action.response.messages}
        case MessageActionType.ERROR:
            return {...state, status : MessageStatus.ERROR};
        case MessageActionType.MESSAGES_REQUEST:
            return {...state, status : MessageStatus.LOADING};
        case MessageActionType.MESSAGES_RESPONSE:
            return {
                ...state, 
                status : MessageStatus.DONE, 
                messages : action.messages, 
                unread: action.unread,
                hasMore: action.messages.length === 20, // If we got less than 20 messages, there are no more to load
                currentOffset: 20 // Set initial offset to 20 since we loaded first page
            };
        case MessageActionType.MESSAGES_APPEND:
            return {
                ...state,
                status: MessageStatus.DONE,
                messages: [...(state.messages || []), ...action.messages],
                unread: action.unread,
                hasMore: action.messages.length === 20, // If we got less than 20 messages, there are no more to load
                currentOffset: (state.currentOffset || 0) + 20 // Increment by page size
            };
        case MessageActionType.MARK_READ:
            let message = action.message;
            let index = state.messages.findIndex((m : UserMessageMinimalProjection) => m.id == action.message.id);
            if(index != -1) {
                let messages : UserMessageMinimalProjection[] = state.messages.concat();
                messages.splice(index, 1, message);
                return {
                    ...state,  
                    messages : messages,
                    unread: state.unread > 0 ? state.unread - 1 : 0
                };
            }
            return state;
        case MessageActionType.MARK_ALL_AS_READ:
            return {...state, unread : 0};
        default:
            return state;
    }
}